<template>
  <div v-transfer-dom :data-transfer="transfer">
    <transition name="toast" @after-leave="animationEnd">
      <div :class="toastClasses" v-if="visible" v-html="message">
        <div :class="prefixCls+'-bg'"></div>
        <slot></slot>
      </div>
    </transition>
  </div>

</template>

<script>
  const prefixCls = "nio-toast"
  import TransferDom from '../../directives/transfer-dom'

  export default {
    name: "",
    directives: {
      TransferDom
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      message: {
        type: String,
        default: '内容'
      },
      transfer: {
        type: Boolean,
        default: true
      },
      position: {
        type: String,
        default: 'middle'
      },
      duration: {
        type: Number,
        default: 2000
      }
    },
    data() {
      return {
        prefixCls: prefixCls,
        visible: true,
        timer: null
      }
    },
    methods: {
      close() {
        this.visible = false
        this.$on('on-animation-end',()=>{
          document.body.removeChild(this.$el);
          this.$destroy();
        })
      },
      animationEnd(){
        this.$emit('on-animation-end')
      }
    },
    computed: {
      toastClasses() {
        return [
          `${prefixCls}`,
          `${prefixCls}-${this.position}`
        ]
      }
    },
    watch: {
      value: {
        handler(val) {
          this.visible = val;
          if (val) {
            this.timer = setTimeout(() => {
              this.visible = false;
              this.$emit('input', false);
              clearTimeout(this.timer);
            }, this.duration)
          }
        },
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scope type="text/scss">
  @import "../../scss/index";




</style>



// WEBPACK FOOTER //
// src/components/toast/toast.vue